import {NgModule} from '@angular/core';
import {FbUploadFileComponent} from './components/fb-upload-file/fb-upload-file.component';
import {MatIconModule} from '@angular/material/icon';
import {CommonModule} from '@angular/common';
import {ngfModule} from 'angular-file';


@NgModule({
  declarations: [FbUploadFileComponent],
  imports: [CommonModule, MatIconModule, ngfModule],
  exports: [FbUploadFileComponent],
  providers: [],
})
export class FormbirdUploadModule {
}
